import { useContext } from 'react'

import { DataContext } from '../../constants'

const useData = () => {
    const context = useContext(DataContext)

    if (context === undefined) {
        throw new Error('DataContext must be within provider')
    }

    return context
}

export default useData
